import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Lock, ShieldCheck } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Account() {
  const { user } = useAuth();
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password.length < 8) { toast.error("New password must be at least 8 characters"); return; }
    if (form.new_password !== form.confirm) { toast.error("New passwords do not match"); return; }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: form.current_password, new_password: form.new_password });
      toast.success("Password updated");
      setForm({ current_password: "", new_password: "", confirm: "" });
    } catch (e2) {
      toast.error(formatApiError(e2.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  const inputCls = "w-full rounded-xl border border-border bg-background px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#2CACD4]";

  return (
    <div className="max-w-md" data-testid="admin-account">
      <h1 className="font-display font-black uppercase text-3xl flex items-center gap-3"><ShieldCheck className="text-[#2CACD4]" /> Account</h1>
      <p className="mt-1 text-muted-foreground text-sm">Signed in as <span className="font-semibold text-foreground">{user?.email}</span> · <span className="uppercase text-[#DB1A5C] font-bold">{user?.role}</span></p>

      <form onSubmit={submit} className="mt-8 rounded-2xl border border-border bg-card p-6" data-testid="change-password-form">
        <h2 className="font-display font-black uppercase text-lg flex items-center gap-2"><Lock size={18} /> Change password</h2>
        <div className="mt-5 space-y-4">
          <div>
            <label className="block text-sm font-semibold mb-1.5">Current password</label>
            <input type="password" required value={form.current_password} onChange={set("current_password")} className={inputCls} autoComplete="current-password" data-testid="account-current" />
          </div>
          <div>
            <label className="block text-sm font-semibold mb-1.5">New password</label>
            <input type="password" required value={form.new_password} onChange={set("new_password")} className={inputCls} autoComplete="new-password" data-testid="account-new" />
          </div>
          <div>
            <label className="block text-sm font-semibold mb-1.5">Confirm new password</label>
            <input type="password" required value={form.confirm} onChange={set("confirm")} className={inputCls} autoComplete="new-password" data-testid="account-confirm" />
          </div>
        </div>
        <button type="submit" disabled={saving} className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#0F172A] text-white hover:bg-[#2CACD4] hover:text-slate-950 font-bold px-6 py-3 transition-colors cursor-pointer disabled:opacity-60" data-testid="account-save">
          {saving ? <Loader2 className="animate-spin" size={18} /> : "Update password"}
        </button>
      </form>
    </div>
  );
}
